import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import "firebase/compat/auth";
import { disableNetwork } from "firebase/firestore";
import { enableNetwork } from "firebase/firestore";

export const config = {
	apiKey: "AIzaSyDmb_OFlZGDaR7vuzmEOHaplQsn_N9sQQk",
	authDomain: "tchqualidade.firebaseapp.com",
	databaseURL: "https://tchqualidade.firebaseio.com",
	projectId: "tchqualidade",
	storageBucket: "tchqualidade.appspot.com",
	messagingSenderId: "502516340829",
	appId: "1:502516340829:web:7826551bdfafc45584d5b4",
	measurementId: "G-9SBEPB2P1C"
};

// const config1 = {
// 	apiKey: "AIzaSyBKwBPW-nCmarCuq8Fsv-4T22Cq7z3oJgE",
// 	authDomain: "pokernashcalc.firebaseapp.com",
// 	databaseURL: "https://pokernashcalc.firebaseio.com",
// 	projectId: "pokernashcalc",
// 	storageBucket: "pokernashcalc.appspot.com",
// 	messagingSenderId: "498910663704",
// 	appId: "1:498910663704:web:5417fe53d8454d2b7a9f6d",
// 	measurementId: "G-4MBR8LCDBK"
// }

class FirebaseUtil {
	constructor() {
		this.networkDisabled = false;
		app.initializeApp(config)
		this.currentUser = null;
		this.auth = app.auth()

		this.db = app.firestore()


		this.db.settings({
			cacheSizeBytes: app.firestore.CACHE_SIZE_UNLIMITED
		});


		this.db.enablePersistence({ synchronizeTabs: true }).catch(function (err) {
			console.log("Erro ao ativar persistencia offline: ", err);
			if (err.code === 'failed-precondition') {
				// Multiple tabs open, persistence can only be enabled
				// in one tab at a a time.
				// ...
			} else if (err.code === 'unimplemented') {
				// The current browser does not support all of the
				// features required to enable persistence
				// ...
			}
		});
		if (window.cordova) {
			// this.disableNetwork()
		}

	}

	firestore() {
		return app.firestore
	}

	disableNetwork() {
		disableNetwork(this.db).then(() => {
			console.log("Network disabled!");
			this.networkDisabled = true;
		});

	}
	enableNetwork() {

		enableNetwork(this.db).then(() => {
			console.log("Network enabled!");
			this.networkDisabled = false;
		});
	}

	login(email, password) {
		return this.auth.signInWithEmailAndPassword(email, password)
	}


	logout() {
		this.currentUser = null;
		return this.auth.signOut()
	}

	async register(name, email, password) {
		await this.auth.createUserWithEmailAndPassword(email, password)
		return this.getCurrentUser().updateProfile({
			displayName: name
		})
	}

	async registerNoLogin(email, password) {
		return new Promise((resolve, reject) => {
			let secondaryApp = app.initializeApp(config, "Secondary")

			secondaryApp.auth().createUserWithEmailAndPassword(email, password).then(
				(firebaseUser) => {
					// console.log('firebaseUser', firebaseUser)
					console.log("User created successfully!" /*+ firebaseUser.user.uid*/);
					secondaryApp.auth().signOut();
					resolve(firebaseUser)
				}).catch(error => {
					reject(error)
				})
		})
		// return this.getCurrentUser().updateProfile({ displayName: name })
	}

	isInitialized() {
		return new Promise(resolve => {
			this.auth.onAuthStateChanged((r) => {
				this.currentUser = r;
				console.log('logado onAuthStateChanged', r)
				resolve(r);
			})
		})
	}

	getCurrentUsername() {
		return this.getCurrentUser() && this.getCurrentUser().displayName
	}
	getCurrentUser() {
		if (this.currentUser) {
			return this.currentUser;
		}
		return this.auth.currentUser
	}
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new FirebaseUtil()